import React from 'react'
import styles from './Main.module.scss'
import InitialPage from '../../components/initialPage/InitialPage'
import Questions from '../../components/Questions/Questions'
import Map from '../../components/Map/Map'
import Advantages from '../../components/Advantages/Advantages'
import Feedback from '../../components/Feedback/Feedback'
import Practical from '../../components/Practical/Practical'
import Portfolio from '../../components/Portfolio/Portfolio'
import Services from '../../components/Services/Services'

const Main = ({isOpen, isImageOpen}) => {

    return (
        <section className={styles.main}>
            <InitialPage
                isOpen={isOpen}
            />
            <Services/>
            <Advantages/>
            <Portfolio
                isImageOpen={isImageOpen}
            />
            <Feedback/>
            <Questions/>
            <Practical/>
            <Map/>
        </section>
    )
}

export default Main